<div class="body_wrapper">
  <section class="notfound-main">
    <div class="mini-container">
      <div class="notfound-content-wrap">
        <img src="../../../assets/img/notfound-img.png" alt="404" class="img-fluid">
        <h2>{{errorMessage.PageNotFound}}</h2>
        <p>{{errorMessage.SorryForInconvinentMessage}} <br>{{errorMessage.GoBack}}</p>
        <a class="notfound-btn" href="/">Home page</a>
      </div>
    </div>
  </section>
</div>